import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.classes_instructors_rel'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Classes -> Instructors',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: 1,
      fetch: 1,
      update: 1,
      delete: 1,
      downloadList: 1,
      uploadList: -1
    }
  },

  controllerDefaultParams: (state, getters, rootState) => {
    return {
      fetch: { org_id: getSessionContext().org_id }
    }
  },

  columns: (state, getters, rootState) => {
    return [
      { name: 'row_menu', type: 'row_menu', menuItemShortcuts: [ 'create', 'copy', 'delete' ], hideWhenCreating: true },
      { name: 'class_id', label: 'Class', field: 'class_id', required: true, references: 'ci.classes', hideWhenDisplaying: true },
      { name: 'instructor_id', style: 'white-space:nowrap', label: 'Instructors', field: 'instructor_id', required: true, references: rootState['ci.instructors'].list, editable: true }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
